module.exports = new __parcel__URL__("logo.41ae7c84.png").toString();